module.exports = __webpack_public_path__ + "img/wink-pantalla-left.2310c866.jpg";